module.exports = __webpack_public_path__ + "static/media/check.10455e8c.svg";